module.exports = __webpack_public_path__ + "img/icon34.7104c52f.png";